<template>
  <v-form ref="form">
    <div class="text-h5 font-weight-bold text-center indigo--text mb-5">Log in</div>
    <v-text-field
        v-model="username"
        label="Email"
        required
        outlined
        dense
    ></v-text-field>
    <v-text-field
        v-model="password"
        label="Password"
        required
        outlined
        dense
        :append-icon="!show ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="show = !show"
        :type="show ? 'password' : 'text'"
    ></v-text-field>

    <v-btn class="mr-4 white--text" @click="submit" color="indigo" block :disabled="disabled">
      Log in
    </v-btn>
    <p class="forgot-link">
      <router-link class="nav-link menu" to="forgot-password">Forgot your password?</router-link>
    </p>
    <p class="d-flex justify-center red--text mt-3 mb-0 text-center">{{ error }}</p>
  </v-form>
</template>


<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      invalidCredentials: false,
      error: "",
      disabled: false,
      show: true
    };
  },
  methods: {
    submit() {
      this.disabled = true
      this.error = ""
      this.$store
          .dispatch("auth/login", {
            username: this.username,
            password: this.password,
            showErrorMessage: (message) => {
              this.error = message
            },
          }).then(() => {
        this.disabled = false
        this.show = true
      })
    },
  },
};
</script>

<style scoped>
.forgot-link {
  padding-top: 20px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;
  color: #3F51B5;
}

.forgot-link a {
  text-decoration: none;
}
</style>